/*
 * Archivio Nobile — carosello immagini prodotto (robusto).
 * Sostituisce i vecchi script inline che usavano document.currentScript.closest(...)
 * (fragili: se lo <script> era fuori dal wrapper, root era null e non si agganciava nulla).
 *
 * Inizializza OGNI [data-carousel] non ancora inizializzato:
 *  - al DOMContentLoaded (storefront)
 *  - all'evento shopify:section:load (theme editor, re-render sezione)
 *  - subito (se il DOM è già pronto)
 *
 * Le frecce/puntini chiamano preventDefault + stopPropagation perché la card
 * può essere avvolta in un <a href="/products/..."> (immagine cliccabile).
 */
(function () {
  function initCarousel(vp) {
    if (vp.__anInit) return;
    vp.__anInit = true;

    var slides = Array.prototype.slice.call(vp.querySelectorAll('.product-carousel-slide'));
    var dots = Array.prototype.slice.call(vp.querySelectorAll('[data-dot]'));
    var n = slides.length;
    if (n === 0) return;
    var i = 0;
    var touchX = null;

    function render() {
      slides.forEach(function (s, idx) {
        s.style.opacity = idx === i ? 1 : 0;
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });
      dots.forEach(function (d, idx) {
        if (idx === i) { d.classList.add('is-active'); }
        else { d.classList.remove('is-active'); }
      });
    }

    function go(d) { i = (i + d + n) % n; render(); }

    vp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
    vp.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      if (touchX == null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      touchX = null;
    });
    vp.querySelectorAll('[data-go]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        go(parseInt(b.getAttribute('data-go'), 10));
      });
    });
    dots.forEach(function (b, idx) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        i = idx; render();
      });
    });

    render();
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
})();
